export const PlayIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.7526 5.47253C10.7891 4.86326 9.57812 4.84318 8.59505 5.41227C7.61198 5.98137 7 7.05261 7 8.21758V31.7848C7 32.9498 7.61198 34.0211 8.59505 34.5901C9.57812 35.1592 10.7891 35.1325 11.7526 34.5299L30.5026 22.7463C31.4336 22.1638 32 21.126 32 20.0012C32 18.8764 31.4336 17.8453 30.5026 17.2562L11.7526 5.47253Z" />
    </svg>
  )
}